import { ElMessage } from 'element-plus'

const typeMsg = (message, type) => {

	return ElMessage({
		message,
		type
	})
}

const successMsg = ($message) => {
	return typeMsg($message, "success")
}

const warningMsg = ($message) => {
	return typeMsg($message, "warning")
}

const errMsg = ($message) => {
	return typeMsg($message, "error")
}

export {
	errMsg,
	successMsg,
	warningMsg
}
